import React from 'react';
export function Nav() {
  return <header className="sticky top-0 z-50 w-full border-b border-white/5 bg-[#0a0a0a]/95 backdrop-blur supports-[backdrop-filter]:bg-[#0a0a0a]/80" data-id="element-123">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between" data-id="element-124">
        <div className="flex items-center gap-2" data-id="element-125">
          <span className="font-serif text-lg font-semibold tracking-widest text-[#d4a437]" data-id="element-126">
            AFFILIATE WAVE
          </span>
        </div>
        <a href="https://d4chc.bemobtracks.com/click" target="_blank" rel="noopener noreferrer" className="inline-flex h-9 items-center justify-center rounded-md bg-[#d4a437] px-4 py-2 text-sm font-medium text-[#0a0a0a] transition-colors hover:bg-[#b88c2e] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#d4a437]" data-id="element-127">
          Únete Ahora
        </a>
      </div>
    </header>;
}